import { render, staticRenderFns } from "./empty-cart.vue?vue&type=template&id=4c15fc82&"
import script from "./empty-cart.vue?vue&type=script&lang=js&"
export * from "./empty-cart.vue?vue&type=script&lang=js&"
import style0 from "./empty-cart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports